/**
 * prekeys.js — wrapper client per il prekey bundle (X3DH / Forward Secrecy).
 * Pubblica/preleva il bundle dal server (storage stupido: la firma SPK si
 * verifica client-side contro la identity sign key, nel modulo X3DH).
 */
import { callFn } from './firebase';

function unwrap(res, what) {
  const d = res?.data;
  if (!d?.ok) throw new Error(d?.error || `${what} fallito`);
  return d;
}

/** Pubblica la signed prekey firmata + chiave KEM PQ + un lotto di one-time prekey. */
export async function publishPrekeys({ sigil, spkPub, spkSig, spkId, pqPub, opks }) {
  return unwrap(await callFn('publishPrekeys')({ sigil, spkPub, spkSig, spkId, pqPub, opks }), 'publishPrekeys');
}

/**
 * Preleva il bundle di un destinatario (consuma UNA one-time prekey).
 * Ritorna { identityKeyBox, identityKeySign, spk:{pub,sig,id}|null, opk:{id,pub}|null }.
 */
export async function fetchPrekeyBundle(sigil) {
  return unwrap(await callFn('fetchPrekeyBundle')({ sigil }), 'fetchPrekeyBundle');
}
